import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { FaImage, FaTimes, FaUser } from "react-icons/fa";
import { toast } from "react-toastify";
import InputField from "../../SharedComponent/Fields/InputField";
import TextareaField from "../../SharedComponent/Fields/TextareaField";
import SelectField from "../../SharedComponent/Fields/SelectField";
import Button from "../../SharedComponent/Button/Button";
import { API_END_POINTS } from "../../network/apiEndPoint";
import { getProtected, patchProtected } from "../../network/ApiService";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import { baseURlNoAPI } from "../../network/baseUrl";
import HeroSection from "../HeroSection/HeroSection";

const initialCustomer = {
  // Company Information
  company_name: "",
  company_registration_number: "",
  vat_registration_number: "",
  managing_director: "",
  homepage: "",

  // Company Address
  street_address_1: "",
  street_address_2: "",
  zip_code: "",
  city: "",
  country: "",

  // Company Contact
  phone_number: "",
  email: "",
  invoiceEmail: "",

  // Contact Person
  contact_first_name: "",
  contact_last_name: "",
  contact_phone_number: "",
  contact_email: "",

  // Company Logo
  company_logo_url: "",

  // Contact Image
  contact_image_url: "",
};

const UpdateCustomerPage = ({ editCustomer }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [values, setValues] = useState({ ...initialCustomer });
  const params = useParams();

  const [contactImage , setContactImage ] = useState("") ; 
  const [companyImage , setCompanyImage] = useState("")  ;
  const [showLoader , setShowLoader ] = useState(false) ; 
  const [loading , setLoading] = useState(false) ; 
 
  useEffect(() => {console.log("values = " , values)} ,[values] ) ; 

  const onClose = () => {
    navigate("/dashboard");
  };

  const getCustomerById = async () => {
    
    const id = params.id;
    if (!id) return;
    const url = `${API_END_POINTS.customers}${id}/`;
    console.log("url = ", url);
    setShowLoader(true) ;
    try {
      // setLoader(true);
      const response = await getProtected(url);
      console.log("fetching specific customer by id = ", response);
      setValues({ ...response[0] });
      if(response?.[0].company_logo_url)
      {
        setCompanyImage(baseURlNoAPI + response?.[0].company_logo_url);
      }
      if(response?.[0].contact_image_url)
      {
        setContactImage(baseURlNoAPI +response?.[0].contact_image_url )
      }
    } catch (e) {
      console.error(e);
      toast.error("Something went wrong !");
    } finally {
     
      setShowLoader(false) ;
    }
  };

  useEffect(() => {
    getCustomerById();
  }, []);

  useEffect(() => {
    if (editCustomer) {
      setValues({ ...initialCustomer, ...editCustomer });
    }
  }, [editCustomer]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setValues((prev) => ({ ...prev, [name]: value }));
  };

  function isValidURL(url) {
    const pattern = /^(https?:\/\/)[^\s/$.?#].[^\s]*$/i;
    return pattern.test(url.trim());
  }


  const handleUpdateCustomer = async (e) => {
    
    e.preventDefault();

    if(!values.homepage == "" && !isValidURL(values.homepage))
      {
        toast.error("Plese enter a valid url in homepage "); 
        return ;
      }

      if(isNaN ( Number(values.zip_code) )  ) 
        {
          toast.error("Zip code must be integer") ; 
          return; 
        }
    console.log("values = "  , values ) ; 
    setLoading(true) ;
    try {
      const id = params?.id;
      if (!id) return;
      const url = `${API_END_POINTS.customers}${id}/`;
      const formData = new FormData();
      for (const key in values) {
        const value = values[key];
        if (typeof value === "string" && value.startsWith("/media/")) continue;
        if (value !== undefined && value !== null) {
          formData.append(key, value);
        }
      }
  
      const response = await patchProtected(url, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
  
      if (response) {
        onClose();
        toast.success("Customer updated successfully!");
      }
    } catch (error) {
      console.error("Update customer error:", error);
      const message = error?.response?.data?.messages?.[0]?.message;
      toast.error(message || "Something went wrong!");
    }
    finally{
      setLoading(false) ; 
    }
  };

  if (showLoader) {
    return (
      <div className="fixed inset-0 flex items-center justify-center bg-gray-800 bg-opacity-75 z-50">
        <div className="text-center px-4 w-full max-w-sm">
          <div className="mx-auto h-12 w-12 sm:h-14 sm:w-14 mb-4 sm:mb-6">
            <div className="animate-spin h-full w-full border-4 sm:border-8 border-gray-200 border-t-blue-500 rounded-full"></div>
          </div>
          <div className="text-white text-lg sm:text-xl font-medium break-words">
            {/* {t("detailViewModel.loadingDetailView")} */}
            Loading edit customer page ..
          </div>
        </div>
      </div>
    );
  }

  

  return (
    <div className="w-full bg-white  px-4 sm:px-6 lg:px-8">
       <HeroSection t={t} showText={false}  />
      <div className="w-full max-w-7xl mx-auto py-6">
        <h2 className="text-2xl font-semibold mb-6">
          {t("customers.update.title")}
        </h2>

        <form onSubmit={handleUpdateCustomer} className="space-y-6">
          {/* Company Information Section */}
          <div className="bg-gray-50 p-4 rounded-lg">
            <h3 className="text-lg font-medium mb-3 text-gray-800">
              {t("createCustomerDashboard.companyInformation")}
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-5 gap-4">
              <InputField
                name="company_name"
                value={values.company_name || ""}
                onChange={handleChange}
                maxLength={100}
                required
                explanation={t("createCustomerDashboard.companyName")}
                label={t("createCustomerDashboard.companyName")}
                placeholder={t("createCustomerDashboard.companyNamePlaceholder")}
              />

              <InputField
                name="company_registration_number"
                value={values.company_registration_number || ""}
                onChange={handleChange}
                maxLength={100}
                 explanation={t("createCustomerDashboard.companyRegistrationNumber")}
                label={t("createCustomerDashboard.companyRegistrationNumber")}
                placeholder={t("createCustomerDashboard.companyRegistrationNumberPlaceholder")}
              />

              <InputField
                name="vat_registration_number"
                value={values.vat_registration_number || ""}
                onChange={handleChange}
                maxLength={100}
                explanation={t("createCustomerDashboard.vatRegistrationNumber")}
                title={t("createCustomerDashboard.vatRegistrationNumber")}
                label={t("createCustomerDashboard.vatRegistrationNumber").slice(0,12)+ " ..."}
                placeholder={t("createCustomerDashboard.vatRegistrationNumberPlaceholder")}
              />

              <InputField
                name="managing_director"
                value={values.managing_director || ""}
                onChange={handleChange}
                maxLength={100}
               explanation={t("createCustomerDashboard.managingDirector")}
                label={t("createCustomerDashboard.managingDirector")}
                placeholder={t("createCustomerDashboard.managingDirectorPlaceholder")}
              />

              <InputField
                 type = "url"
                name="homepage"
                value={values.homepage || ""}
                onChange={handleChange}

                maxLength={100}
                 explanation={t("createCustomerDashboard.homepage")}
                label={t("createCustomerDashboard.homepage")}
                placeholder="https://www.company.com"
              />
            </div>
          </div>

          {/* Company Address Section */}
          <div className="bg-gray-50 p-4 rounded-lg">
            <h3 className="text-lg font-medium mb-3 text-gray-800">
             {t("createCustomerDashboard.companyAddress")}
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-5 gap-4">
              <InputField
                name="street_address_1"
                value={values.street_address_1 || ""}
                onChange={handleChange}
                maxLength={100}
                required
                 explanation={t("createCustomerDashboard.streetAddress1")}
                label={t("createCustomerDashboard.streetAddress1")}
                placeholder={t("createCustomerDashboard.streetAddressPlaceholder")}
              />

              <InputField
                name="street_address_2"
                value={values.street_address_2 || ""}
                onChange={handleChange}
                maxLength={100}
                 explanation={t("createCustomerDashboard.streetAddress2")}
                label={t("createCustomerDashboard.streetAddress2")}
                placeholder={t("createCustomerDashboard.streetAddressPlaceholder2")}
              />

              <InputField
                type="number"
                name="zip_code"
                value={values.zip_code || ""}
                onChange={handleChange}
                maxLength={100}
                required
                explanation={t("createCustomerDashboard.zipCode")}
                label={t("createCustomerDashboard.zipCode")}
                placeholder={t("createCustomerDashboard.zipCodePlaceholder")}
              />

              <InputField
                name="city"
                value={values.city || ""}
                onChange={handleChange}
                required
                explanation={t("createCustomerDashboard.city")}
                label={t("createCustomerDashboard.city")}
                placeholder={t("createCustomerDashboard.cityPlaceholder")}
              />

              <InputField
                name="country"
                value={values.country || ""}
                onChange={handleChange}
                maxLength={100}
                required
                explanation={t("createCustomerDashboard.country")}
                label={t("createCustomerDashboard.country")}
                placeholder={t("createCustomerDashboard.countryPlaceholder")}
              />
            </div>
          </div>

          {/* Company Contact Section */}
          <div className="bg-gray-50 p-4 rounded-lg">
            <h3 className="text-lg font-medium mb-3 text-gray-800">
              {t("createCustomerDashboard.companyContactInformation")}
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
              <InputField
                name="phone_number"
                value={values.phone_number || ""}
                onChange={handleChange}
                required
                type="text"
                maxLength={20}
                 explanation={t("createCustomerDashboard.phone")}
                label={t("createCustomerDashboard.phone")}
                placeholder="+49 123 4567890"
              />

              <InputField
                name="email"
                value={values.email || ""}
                onChange={handleChange}
                maxLength={50}
                type="email"
                required
                 explanation={t("createCustomerDashboard.email")}
                label={t("createCustomerDashboard.email")}
                placeholder="contact@company.com"
              />

              <InputField
                name="invoiceEmail"
                value={values.invoiceEmail || ""}
                onChange={handleChange}
                maxLength={50}
                type="email"
                 explanation={t("createCustomerDashboard.invoiceEmail")}
                label={t("createCustomerDashboard.invoiceEmail")}
                placeholder="invoice@company.com"
              />
            </div>
          </div>

          <div className="bg-gray-50 p-4 rounded-lg">
            <h3 className="text-lg font-medium mb-3 text-gray-800">
              {t("createCustomerDashboard.contactPersonPlaceholder")}
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
              <InputField
                name="contact_first_name"
                value={values.contact_first_name || ""}
                onChange={handleChange}
                maxLength={50}
                explanation={t("createCustomerDashboard.firstName")}
                label={t("createCustomerDashboard.firstName")}
                placeholder={t("createCustomerDashboard.firstNamePlaceholder")}
              />

              <InputField
                name="contact_last_name"
                value={values.contact_last_name || ""}
                onChange={handleChange}
                maxLength={50}
                explanation={t("createCustomerDashboard.lastName")}
                label={t("createCustomerDashboard.lastName")}
                placeholder={t("createCustomerDashboard.lastNamePlaceholder")}
              />

              <InputField
                name="contact_phone_number"
                value={values.contact_phone_number || ""}
                onChange={handleChange}
                maxLength={20}
                explanation={t("createCustomerDashboard.contactPhone")}
                label={t("createCustomerDashboard.contactPhone").slice(0,12) + " ..."}
                placeholder="+49 172 1234567"
              />

              <InputField
                name="contact_email"
                value={values.contact_email || ""}
                onChange={handleChange}
                maxLength={50}
                type="email"
                 explanation={t("createCustomerDashboard.contactEmail")}
                label={t("createCustomerDashboard.contactEmail").slice(0,12) + " ..."}
                placeholder="contact.person@company.com"
              />
            </div>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
            {/* Company Logo Section */}
           {companyImage && <div className="bg-gray-50 p-4 rounded-lg">
              <h3 className="text-lg font-medium mb-3 text-gray-800 flex items-center">
                <FaImage className="w-5 h-5 mr-2" />
              {t("createCustomerDashboard.companyLogo")}
              </h3>
              <div className="space-y-4">
                {/* Logo Preview */}
                {companyImage && (
                  <div className="mt-4">
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                     {t("createCustomerDashboard.logoPreviewPlaceholder")}
                    </label>
                    <div
                      className="border border-gray-300 rounded-md p-4 bg-white flex items-center justify-center"
                      style={{ minHeight: "120px" }}
                    >
                      <img
                        src={companyImage}
                        alt="Company Logo"
                        className="max-h-20 max-w-full object-contain"
                        onError={(e) => {
                          e.target.style.display = "none";
                          e.target.nextSibling.style.display = "block";
                        }}
                      />
                      <div className="text-gray-500 text-sm hidden">
                        {t("createCustomerDashboard.logoNotAvailablePlaceholder")}
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>}

            {/* Contact Image Section */}
           { contactImage && <div className="bg-gray-50 p-4 ">
              <h3 className="text-lg font-medium mb-3 text-gray-800 flex items-center">
                <FaUser className="w-5 h-5 mr-2" />
                {t("createCustomerDashboard.contactPersonImage")}
              </h3>
              <div className="space-y-4">
                {/* Contact Image Preview */}
                {contactImage && (
                  <div className="mt-4">
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      {t("createCustomerDashboard.contactPersonImage")}
                    </label>
                    <div
                      className="border border-gray-300 rounded-md p-4 bg-white flex items-center justify-center"
                      style={{ minHeight: "120px" }}
                    >
                      <img
                        src={contactImage}
                        alt="Contact Person"
                        className="max-h-20 max-w-full object-contain "
                        onError={(e) => {
                          e.target.style.display = "none";
                          e.target.nextSibling.style.display = "block";
                        }}
                      />
                      <div className="text-gray-500 text-sm hidden">
                        {t("createCustomerDashboard.contactImageNotAvailablePlaceholder")}
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>}
          </div>

          {/* Contact Person Section */}
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
            {/* Company Logo Section */}
            <div className="bg-gray-50 p-4 rounded-lg">
              <h3 className="text-lg font-medium mb-3 text-gray-800">
                {t("createCustomerDashboard.companyLogoPlaceholder")}
              </h3>
              <div className="space-y-4">
              <input
                  name="company_logo_url"
                  onChange={(e) =>
                  {
                    setValues({
                      ...values,
                      company_logo_url: e.target.files[0],
                    })
                    setCompanyImage(URL.createObjectURL(e.target.files[0]))
                  }
                    
                  }
                  type="file"
                  accept="image/*"
                />
              </div>
            </div>

            {/* Contact Image Section */}
            <div className="bg-gray-50 p-4 rounded-lg">
              <h3 className="text-lg font-medium mb-3 text-gray-800">
               {t("createCustomerDashboard.contactPersonImage")}
              </h3>
              <div className="space-y-4">
                <input
                  name="contact_image_url"
                  onChange={(e) =>
                  {
                    setValues({
                      ...values,
                      contact_image_url: e.target.files[0],
                    })
                    setContactImage(URL.createObjectURL(e.target.files[0])) ; 
                  }
                  }
                  type="file"
                  accept="image/*"
                />
              </div>
            </div>
          </div>

          <div className="flex flex-col sm:flex-row items-center justify-end gap-4 pt-4">
            <button
              type="button"
              onClick={onClose}
              
              className="w-full sm:w-auto px-6 py-2 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
            >
              {t("customers.create.buttons.cancel")}
            </button>

            <button
              type="submit"
              disabled={loading}
              className={`${loading ? "cursor-not-allowed" : "cursor-pointer" } w-full sm:w-auto px-6 py-2 bg-indigo-600 border border-transparent rounded-md shadow-sm text-sm font-medium text-white hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 `}
            >
              {t("customers.update.buttons.update")}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default UpdateCustomerPage;
